import { __assign } from "tslib";
import { deliveryMethodIcons } from '../../constants/delivery-method-icons';
import { deliveryMethodImages } from '../../constants/delivery-method-images';
export var getDeliveryMethodsBadges = function (t, deliveryMethods) {
    var notUndefined = function (x) { return Boolean(x); };
    return deliveryMethods === null || deliveryMethods === void 0 ? void 0 : deliveryMethods.map(function (deliveryMethod) {
        var maybeIcon = deliveryMethodIcons[deliveryMethod];
        var maybeImage = deliveryMethodImages[deliveryMethod];
        if (maybeIcon || maybeImage) {
            var iconObject = maybeIcon ? { icon: maybeIcon } : {};
            var imageObject = maybeImage ? { image: { url: maybeImage } } : {};
            return __assign(__assign({ text: t("delivery.method.text." + deliveryMethod.toLocaleLowerCase()), visibleBy: 'PRIVILEGED' }, iconObject), imageObject);
        }
    }).filter(notUndefined);
};
//# sourceMappingURL=deliveryMethodHelpers.js.map